import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { Button, Col, Row, Form } from 'react-bootstrap';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import {
  AuthedLayout,
  EditableTableDiv,
  HeaderDisplayKeysWithType,
  EditableProperties,
  DateTimePicker,
} from '../../../components';
import { useClassGrade, useSemGrade } from '../../../hook';
import { StudentGradeNoSeatBirth, WH } from '../../../model';
import apis from '../../../apis';
import { SightContext } from '../../TableHeaders/SightHeader';
import { downloadDataAsExcel, SheetHeaderDisplay } from '../../../utils';
import { whbmiDiag } from '../../../utils/sight';
import { Nullable } from '../../../types';
import { DateTime } from 'luxon';
import { WrapClassBaseLayout, ClassSem } from '../../../layouts';
import ReactDatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
type PageData = StudentGradeNoSeatBirth & WH & { diag: string } & EditableProperties & { fitbmistr: string } & { fitweightstr: string } & { age: number };

const tableHeader: (SheetHeaderDisplay<PageData> &
  HeaderDisplayKeysWithType<PageData>)[] = [
    { display: '座號', property: 'seat' },
    { display: '姓名', property: 'name' },
    {
      display: '性別',
      property: 'sex',
      onRender: (v) => (v === '1' ? '男' : '女'),
      onSheetRender: (v) => (v === '1' ? '男' : '女'),
    },
    { display: '身高', property: 'height' },
    { display: '體重', property: 'weight' },
    {
      display: '測量日',
      property: 'examDate',
      onRender: (v) => {
        return v instanceof DateTime ? v.toFormat('yyyy/MM/dd') : v;
      },
    },
    { display: '體位', property: 'diag' },
    { display: '身高不足標準', property: 'fitHeight', style: { width: '5%' } },
    { display: 'BMI', property: 'bmi' },
    {
      display: '實歲',
      property: 'age'
    },
    { display: '建議BMI', property: 'fitbmistr' },
    { display: '建議體重', property: 'fitweightstr' },
  ];

const mapStates = (state: ApplicationState, ownProps: ClassSem) => ({
  ...ownProps,
  ...state.auth,
});
const mapDispatch = ErrorDispatches;

const connector = connect(mapStates, mapDispatch);
type Props = ConnectedProps<typeof connector>;

const wHClassList: FunctionComponent<Props> = ({
  classId,
  className,
  year,
  sem,
  grade,
  no,
  catchErrorForModal,
}) => {
  const { yearSem, element: semGradeElement } = useSemGrade();
  const { selectedClassGrade: classGrade, element: classGradeElement } =
    useClassGrade({
      yearSem,
    });
  const [isNotHealthy, setIsNotHealthy] = useState<boolean>(false);
  // const filterstudents = useMemo(filterBmicode, [isNotHealthy]);
  const [students, setStudents] = useState<PageData[]>([]);
  const [isPrintFitWeight, setIsPrintFitWeight] = useState<boolean>(false);
  const [isPrintFitHeight, setIsPrintFitHeight] = useState<boolean>(false);
  const [isPrintHistories, setIsPrintHistories] = useState<boolean>(false);
  const [wHSightClassListPdfDate, setWHSightClassListPdfDate] =
    useState<DateTime>();

  useEffect(() => {
    if (year && classId) {
      toast
        .promise(
          apis
            .getWHClassStudentBmi(year, sem, classId, isNotHealthy)
            .then(r => {
              setStudents(
                r.map(({ sight, wh, ...s }) => {
                  const { examDate, ...si } = sight || {};
                  return {
                    ...si,
                    ...wh,
                    ...s,
                    diag: whbmiDiag(wh?.bmiCode?.toString()),
                    fitbmistr: (wh?.bmiCode ?? "-1") != "0" ? (s.fitBMI ?? 0).toString() : "",
                    fitweightstr: (wh?.bmiCode ?? "-1") != "0" ? (s.fitWeight ?? 0).toString() : "",
                    age: wh?.examDate ? calculateAge(s.birth, wh?.examDate) : 0
                  };
                })
              );
            }),
          {
            pending: '資料載入中......',
            success: '資料載入成功！',
            error: '資料載入失敗！請查看錯誤資訊。',
          }
        )
        .catch(catchErrorForModal);

    }
  }, [classId, year, sem, isNotHealthy]);

  if (!classId) return <></>;
  return (
    <>
      <Row className="mb-2">
        僅顯示體位不良者：
        <Col sm={1}>
          <Form.Check
            type="checkbox"
            label="是"
            name="bmilevel_bad"
            onChange={(e) => {
              setIsNotHealthy(e.target.checked);
            }}
          />
        </Col>
      </Row>
      <Row className="mb-2">
        衛教內容設定：
        <Col sm={2}>
          <Form.Check
            type="checkbox"
            label="列印建議體重"
            name="education"
            onChange={(e) => {
              setIsPrintFitWeight(e.target.checked);
            }}
          />
        </Col>
        <Col sm={3}>
          <Form.Check
            type="checkbox"
            label="列印歷年身高體重值"
            name="education"
            onChange={(e) => {
              setIsPrintHistories(e.target.checked);
            }}
          />
        </Col>

      </Row>
      <Row className="mb-2">
        回條內容設定：繳回期限（ex.1999/01/01）
        <div style={{ flex: '0 0 25%' }} className="mr-2">
          <DateTimePicker
            containerClass="px-2 py-1"
            value={wHSightClassListPdfDate}
            onChange={(date) => {
              setWHSightClassListPdfDate(date);
            }}
          />
        </div>
        {/* 回條內容設定：繳回期限（ex.1999/01/01）
        <Col sm={1}>
          <ReactDatePicker
            className="wid-110"
            selected={wHSightClassListPdfDate?.toJSDate()}
            onChange={(date) => {
              if (date instanceof Date) {
                setWHSightClassListPdfDate(DateTime.fromJSDate(date));
              } else {
                setWHSightClassListPdfDate(undefined);
              }
            }}
          />
        </Col> */}
      </Row>
      <Row className="mt-3">
        <Button
          className="ml-auto mb-2"
          disabled={!students.length}
          onClick={() => {
            let pids = students
              .filter((s) => s.selected)
              .map((s) => s.pid);

            pids =
              pids.length === 0
                ? students.map((s) => s.pid)
                : pids;

            const pdfPromise = !isPrintHistories
              ? apis.downloadWH85210ClassListPDF(
                classId,
                pids,
                year,
                sem,
                isPrintFitWeight,
                isPrintFitHeight,
                wHSightClassListPdfDate
              )
              : apis.downloadWHHistoryClassListPDF(
                classId,
                pids,
                year,
                sem,
                isPrintFitWeight,
                isPrintHistories,
                wHSightClassListPdfDate
              );

            toast
              .promise(
                pdfPromise,
                {
                  pending: '通知單產生中...',
                  success: '通知單產生成功！',
                  error: '通知單產生失敗！請查看錯誤資訊。',
                }
              )
              .then((blob) => {
                const pdfBlob =
                  blob instanceof Blob
                    ? blob.slice(
                      0,
                      blob.size,
                      'application/pdf'
                    )
                    : new Blob(
                      [blob],
                      {
                        type: 'application/pdf',
                      }
                    );

                const pdfUrl =
                  window.URL.createObjectURL(
                    pdfBlob
                  );

                const pdfWindow =
                  window.open(
                    pdfUrl,
                    '_blank'
                  );

                if (!pdfWindow) {
                  toast.error(
                    '瀏覽器阻擋了 PDF 視窗，請允許彈出式視窗。'
                  );

                  window.URL.revokeObjectURL(
                    pdfUrl
                  );

                  return;
                }

                setTimeout(() => {
                  window.URL.revokeObjectURL(
                    pdfUrl
                  );
                }, 60000);
              })
              .catch(catchErrorForModal);
          }}
        >
          列印通知單
        </Button>
        <EditableTableDiv
          headers={tableHeader}
          values={students}
          context={SightContext}
          onSelected={(s) => {
            // const checkstu = filterstudents.length == 0 ? students : filterstudents;
            if (s.index !== undefined) {
              const v = students[s.index];
              v.selected = s.checked;
            } else {
              students.forEach((v) => {
                v.selected = s.checked;
              });
            }
            setStudents([...students]);
          }}
        />
      </Row>
    </>
  );
};

function calculateAge(birthDate: DateTime, examDate: DateTime): number {
    const birth = new Date(birthDate.year, birthDate.month - 1, birthDate.day);
    const exam = new Date(examDate.year, examDate.month - 1, examDate.day);

    if (exam < birth) return 0;

    const totalDays = (exam.getTime() - birth.getTime()) / (1000 * 60 * 60 * 24);

    const age = Math.floor(totalDays / 365);

    return age < 0 ? 0 : age;
}



export const WHClassList = connector(WrapClassBaseLayout(wHClassList));
